export default __webpack_public_path__ + "static/media/Banner3.174b78ed.png";